import {
  createEventBody,
  createEventParams,
  createEventString,
} from '../actions/logging';

export default function sendCategoryActionLabelEvent(
  tuneInApiClient,
  category,
  action,
  label,
) {
  const eventObj = {
    category,
    action,
    label,
  };

  const event = createEventString(eventObj);
  const body = createEventBody(event);
  const params = createEventParams();

  tuneInApiClient?.logging?.eventLog(params, body);
}
